export default {
  id: 'healthHistory/CHIEF/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.regularAndAcuteMedications',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.regularAndAcuteMedications',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
